module.exports = __webpack_public_path__ + "media/time_tracking/components/FingerPrintAnimation/output-61f9c85296136771ef44c89871591423.jpg";